import axios from "axios";
const getServicesApi = async (
  callback,
  servicesResData,
  lang,
  baseURL,
  loading
) => {
  loading(true);
  try {
    const response = await axios.get(`${baseURL}/website/services`, {
      headers: {
        Accept: "application/json",
        lang: lang,
      },
    });
    // console.log(data);
    servicesResData(response.data.sectionTitle);
    callback(response.data.data.data);
    loading(false);

    return;
  } catch (error) {
    loading(false);

    throw new Error(error);
  }
};

export default getServicesApi;
